import { combineReducers } from '@reduxjs/toolkit';

import { checkoutResetAction } from './checkoutActions';
import { deliveryTabActions, deliveryTabReducer } from './deliveryTabSlice';
import { paymentMethodReducer } from './paymentSlice';
import { punchoutReducer } from './punchoutSlice';
import { subscriptionFrequencyReducer } from './subscriptionSlice';

const combined = combineReducers({
    subscriptionFrequency: subscriptionFrequencyReducer,
    selectedPaymentMethod: paymentMethodReducer,
    punchout: punchoutReducer,
    deliveryTab: deliveryTabReducer,
});

export const checkoutActions = {
    reset: checkoutResetAction,
    deliveryTabActions,
};

export default combined;
